import React, { useContext } from 'react';

export const CurrencyDataContext = React.createContext({});

export const useCurrencyDataContext = () => useContext(CurrencyDataContext);
